import axios from "axios";
import {
  ADD_IDLE_FAIL,
  ADD_IDLE_REQUEST,
  ADD_IDLE_SUCCESS,
  ADD_IDLE_TIME_LIMIT_FAIL,
  ADD_IDLE_TIME_LIMIT_REQUEST,
  ADD_IDLE_TIME_LIMIT_SUCCESS,
  ADD_SCREENSHOT_LIMIT_FAIL,
  ADD_SCREENSHOT_LIMIT_REQUEST,
  ADD_SCREENSHOT_LIMIT_SUCCESS,
  ADD_TIMEHERO_FAIL,
  ADD_TIMEHERO_REQUEST,
  ADD_TIMEHERO_SUCCESS,
  ADD_WEEKLY_LIMIT_FAIL,
  ADD_WEEKLY_LIMIT_REQUEST,
  ADD_WEEKLY_LIMIT_SUCCESS,
  ADD_NOTIFICATION_FAIL,
  ADD_NOTIFICATION_REQUEST,
  ADD_NOTIFICATION_SUCCESS,
  GET_DATA_Of_USER_SETTING_BY_COMPANY_FAIL,
  GET_DATA_Of_USER_SETTING_BY_COMPANY_REQUEST,
  GET_DATA_Of_USER_SETTING_BY_COMPANY_SUCCESS,
  GET_DATA_Of_USER_SETTING_BY_DEPARTMENT_FAIL,
  GET_DATA_Of_USER_SETTING_BY_DEPARTMENT_REQUEST,
  GET_DATA_Of_USER_SETTING_BY_DEPARTMENT_SUCCESS,
  GET_COMPANY_SETTING_FAIL,
  GET_COMPANY_SETTING_REQUEST,
  GET_COMPANY_SETTING_SUCCESS,
  ADD_APP_TRACK_IN_MANAGER_FAIL,
  ADD_APP_TRACK_IN_MANAGER_REQUEST,
  ADD_APP_TRACK_IN_MANAGER_SUCCESS,
} from "../../types/manager/settingType";

//Setting Idle time
export const userIdIdleAction =
  (userId, departId, formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: ADD_IDLE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo.token}`,
        },
      };
      const body = {
        formData,
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/manager/setting/idle/${userId}/${departId}`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: ADD_IDLE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: ADD_IDLE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Setting Idle time
export const userIdIdleTimeAction =
  (userId, idleTime, companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: ADD_IDLE_TIME_LIMIT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = {
        idleTime,
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/manager/setting/${companyId}/idletime/${userId}`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: ADD_IDLE_TIME_LIMIT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: ADD_IDLE_TIME_LIMIT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Setting Screenshot
export const userIdScreenShotAction =
  (ssTime, userId, companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: ADD_SCREENSHOT_LIMIT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = {
        ssTime,
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/manager/setting/${companyId}/screenshot/${userId}/`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: ADD_SCREENSHOT_LIMIT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: ADD_SCREENSHOT_LIMIT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Setting Weekly Limit
export const userIdWeeklyLimitAction =
  (weeklyLimit, userId, companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: ADD_WEEKLY_LIMIT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      // console.log(userId, weeklyLimit);
      let body = {
        weeklyLimit,
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/manager/setting/${companyId}/weekly/${userId}/`,
        body,
        config
      );
      // console.log(data?.data);
      dispatch({
        type: ADD_WEEKLY_LIMIT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: ADD_WEEKLY_LIMIT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Setting notification
export const AddNotifcationAction =
  (notification, companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: ADD_NOTIFICATION_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = {
        notification,
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/manager/setting/${companyId}/notify/all/user`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: ADD_NOTIFICATION_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: ADD_NOTIFICATION_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Get Setting Of Company
export const getSettingForDepAction =
  (companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: GET_DATA_Of_USER_SETTING_BY_COMPANY_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/manager/setting/${companyId}/department/${sharedUserInfo?.payload?.id}`,
        config
      );
      // console.log({ data });
      dispatch({
        type: GET_DATA_Of_USER_SETTING_BY_COMPANY_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: GET_DATA_Of_USER_SETTING_BY_COMPANY_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Get Setting Of Department
export const getSettingForDepartmentAction =
  (departId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: GET_DATA_Of_USER_SETTING_BY_DEPARTMENT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo.token}`,
        },
      };
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/manager/setting/department/${departId}`,
        config
      );
      // console.log(data);
      dispatch({
        type: GET_DATA_Of_USER_SETTING_BY_DEPARTMENT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: GET_DATA_Of_USER_SETTING_BY_DEPARTMENT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Setting Time hero
export const userIdTimeHeroAction =
  (timeHero, userId, companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: ADD_TIMEHERO_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = {
        timeHero,
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/manager/setting/${companyId}/timehero/${userId}`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: ADD_TIMEHERO_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: ADD_TIMEHERO_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Get company setting
export const getCompanySettAction =
  (companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: GET_COMPANY_SETTING_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/manager/setting/${companyId}/company/all/data`,
        config
      );
      dispatch({
        type: GET_COMPANY_SETTING_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: GET_COMPANY_SETTING_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Setting Weekly Limit
export const userIdAppTrackAction =
  (appTrack, userId, companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: ADD_APP_TRACK_IN_MANAGER_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      // console.log(userId, weeklyLimit);
      let body = {
        appTrack,
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/manager/setting/${companyId}/apptrack/${userId}/`,
        body,
        config
      );
      // console.log(data?.data);
      dispatch({
        type: ADD_APP_TRACK_IN_MANAGER_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: ADD_APP_TRACK_IN_MANAGER_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
